import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private env = environment;
    siteUrl = '';
    siteName = '';
    domainUrl = '';
    stripeKey = '';

    chartglobal: any = [];
    constructor(private http: HttpClient, private titleService: Title, private router: Router) {
        this.siteName = this.env.siteName;
        this.siteUrl = this.env.backendUrl;
        this.domainUrl = window.location.origin;
        this.stripeKey = this.env.stripeKey;
    }

    getData(param) {
        return this.http.get(this.env.backendUrl + param, {headers: this.getToken()});
    }

    sendPostRequest(requestUrl: any, postData: any) {
        return this.http.post(this.env.backendUrl + requestUrl, postData, {headers: this.getToken()});
    }
    sendPutRequest(requestUrl: any, postData: any) {
        return this.http.put(this.env.backendUrl + requestUrl, postData, {headers: this.getToken()});
    }

    sendPostRequestwithheaders(requestUrl: any, postData: any,headers:any) {
        return this.http.post(this.env.backendUrl + requestUrl, postData, {headers: this.getToken()});
    }
    deleteData(requestUrl: any) {
        return this.http.delete(this.env.backendUrl + requestUrl,{headers: this.getToken()});
    }
    tokenExpireLogout() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('userName');
        localStorage.removeItem('plan');
        localStorage.removeItem('otpemail');
        this.router.navigate(['']);
    }

    pathInArray() {
        const PathVal = this.router.url;
        return PathVal.substring(1).split('/');
    }

    private getToken() {
        return new HttpHeaders()
            .set('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem('currentUser')));
    }
}
